import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcnClose = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23.994925,
	height: 24,
	viewBox: "0 0 23.994925 24",
	id: "svg3",
	"sodipodi:docname": "icn-close.svg",
	"inkscape:version": "1.3.2 (091e20e, 2023-11-25)",
	"xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
	"xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
	xmlns: "http://www.w3.org/2000/svg",
	"xmlns:svg": "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { id: "defs3" }),
		/* @__PURE__ */ _jsx("sodipodi:namedview", {
			id: "namedview3",
			pagecolor: "#ffffff",
			bordercolor: "#000000",
			borderopacity: .25,
			"inkscape:showpageshadow": 2,
			"inkscape:pageopacity": 0,
			"inkscape:pagecheckerboard": 0,
			"inkscape:deskcolor": "#d1d1d1",
			showgrid: "false",
			"inkscape:zoom": 4.9166667,
			"inkscape:cx": 11.898305,
			"inkscape:cy": 12,
			"inkscape:window-width": 1312,
			"inkscape:window-height": 449,
			"inkscape:window-x": 0,
			"inkscape:window-y": 38,
			"inkscape:window-maximized": 0,
			"inkscape:current-layer": "svg3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "m 21.597025,24 c -0.6124,0 -1.2279,-0.2347 -1.6962,-0.703 L 0.702525,4.0935 c -0.9367,-0.9355 -0.9367,-2.4547 0,-3.3903 0.9366,-0.9376 2.4537,-0.9376 3.3903,0 l 19.2004,19.2035 c 0.9355,0.9356 0.9355,2.4527 0,3.3903 -0.4683,0.4683 -1.0828,0.703 -1.6962,0.703 z",
			id: "path1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "m 12.133225,14.2615 c -0.6145,0 -1.2268,-0.2346 -1.6952,-0.7019 -0.9366,-0.9376 -0.9366,-2.4558 0,-3.3913 l 9.4639,-9.4659 c 0.9407,-0.9366 2.4588,-0.9325 3.3913,0 0.9356,0.9376 0.9356,2.4547 0,3.3903 l -9.4638,9.4669 c -0.4683,0.4673 -1.0828,0.7019 -1.6962,0.7019 z",
			id: "path2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "m 2.397925,23.9999 c -0.6145,0 -1.2279,-0.2347 -1.6962,-0.703 -0.9356,-0.9376 -0.9356,-2.4547 0,-3.3903 l 4.5327,-4.5327 c 0.9397,-0.9356 2.4579,-0.9325 3.3903,0 0.9377,0.9376 0.9377,2.4547 0,3.3903 l -4.5307,4.5327 c -0.4683,0.4683 -1.0837,0.703 -1.6961,0.703 z",
			id: "path3"
		})
	]
});
export default SvgIcnClose;
